import {
  calculateVolumeAndUnits,
  canUseFractionedQuantity,
  convertVolumeAndUnitsToQuantity,
  formatQuantityToVolumeAndUnits,
} from '../../../../../services/util/volume-and-units.service'

function normalizeLabel(value) {
  return typeof value === 'string' ? value.trim() : ''
}

export function getFaltaQuantityConfig(item = {}) {
  const unitSku = Number(item.unit_sku || 0)
  const caixaComPesoVariavel =
    item.caixa_com_peso_variavel === true || Number(item.caixa_com_peso_variavel) === 1

  return {
    unitSku,
    caixaComPesoVariavel,
    unAgregadora: item.un_agregadora || null,
    unFracionada: item.un_fracionada || null,
    canUseFractionedInput: canUseFractionedQuantity(unitSku, caixaComPesoVariavel),
  }
}

export function getFaltaInputLabels(item) {
  const { unAgregadora, unFracionada } = getFaltaQuantityConfig(item)

  return {
    volumeLabel: normalizeLabel(unAgregadora) || 'Vol.',
    unitsLabel: normalizeLabel(unFracionada) || 'Frac.',
  }
}

export function buildFaltaQuantityInputState(item, quantity) {
  const { unitSku, caixaComPesoVariavel } = getFaltaQuantityConfig(item)

  if (quantity === '' || quantity === null || quantity === undefined) {
    return {
      quantityValue: '',
      volumeValue: '',
      unitsValue: '',
    }
  }

  const { volume, units } = calculateVolumeAndUnits(quantity, unitSku, caixaComPesoVariavel)

  return {
    quantityValue: Number(quantity),
    volumeValue: volume === 0 ? '0' : String(volume),
    unitsValue: units === 0 ? '0' : String(Math.abs(units)),
  }
}

export function getFaltaQuantityValueFromInputs(item, volumeValue, unitsValue) {
  const { unitSku, caixaComPesoVariavel, canUseFractionedInput } = getFaltaQuantityConfig(item)

  if (
    volumeValue === '' &&
    (unitsValue === '' || !canUseFractionedInput || caixaComPesoVariavel)
  ) {
    return ''
  }

  return convertVolumeAndUnitsToQuantity({
    volume: volumeValue,
    units: canUseFractionedInput ? unitsValue : 0,
    unitSku,
    caixaComPesoVariavel,
  })
}

export function formatFaltaQuantity(item, quantity) {
  const { unitSku, caixaComPesoVariavel, unAgregadora, unFracionada } = getFaltaQuantityConfig(item)

  return formatQuantityToVolumeAndUnits({
    quantity,
    unitSku,
    caixaComPesoVariavel,
    unAgregadora,
    unFracionada,
  })
}
